import Api from "../../../../services/Api";

function fetchFleetSearchDetails(filterParams = {}) {
  const payload = {
    is: { protocol: "OCPP", isRetired: false, ...filterParams },
  };
  return Api.post("/service/iqevse-csms/charger/v1/query/ev_charger", payload);
}

export { fetchFleetSearchDetails };
